var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChartTemplate',{attrs:{"chartMainData":_vm.getCurrentChartMainData,"chartOptionsFuncParams":_vm.chartOptionsFuncParams,"showYearSelect":false,"courses":"","chartSeriesYKey":"totalUsers","chartTitle":"Курсы"}})
}
var staticRenderFns = []

export { render, staticRenderFns }